import React from "react";
import Layout from "./Layout";

export default function AboutUs() {
  // Add your Google Drive video IDs here
  const videos = [
    {
      url: "https://drive.google.com/file/d/1-dBPdd8XH828omQ3HG6aLw2PULacf5zs/view?usp=sharing",
    },
    {
      url: "https://drive.google.com/file/d/1OfS1EsIMXEUk9jnBUg0v7o2baG28U2L6/view?usp=sharing",
    },
    {
      url: "https://drive.google.com/file/d/1RWs5Xf0fl_bOee4L0icxE94gUQlQV_TP/view?usp=sharing",
    },
    {
      url: "https://drive.google.com/file/d/1VoL1VjWKPy_0qJtaWpyIxtLGvbWJgs2V/view?usp=sharing",
    },
    {
      url: "https://drive.google.com/file/d/1wzyzoSY1wojNclCC5UZvD3waW1qetf05/view?usp=sharing",
    },
  ];

  // Convert Google Drive sharing URL to preview URL
  const getDrivePreviewUrl = (url) => {
    const match = url.match(/\/file\/d\/([^/]+)/);

    if (!match) return "";

    return `https://drive.google.com/file/d/${match[1]}/preview`;
  };

  return (
    <Layout>
      {/* =========================
          ABOUT US
      ========================= */}
      <section className="px-6 md:px-16 py-12 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-black flex flex-col gap-6">
            <h1 className="text-4xl md:text-5xl font-serif text-light_primary">
              About Us
            </h1>

            <p className="text-lg leading-8">
              Legacy Decor is a premium interior and home décor brand dedicated
              to creating beautiful, functional spaces for our customers. With
              years of experience in designing and curating high-quality
              furniture, lighting, and décor pieces, we strive to bring style
              and elegance into every home.
            </p>

            <p className="text-lg leading-8">
              Our mission is to combine aesthetics with comfort, ensuring each
              product meets our rigorous standards of quality and design. We
              believe that a well-decorated space can enhance your lifestyle and
              bring joy to everyday living.
            </p>

            <p className="text-lg leading-8">
              From sourcing the finest materials to working with skilled
              craftsmen, we take pride in offering a curated selection of
              products that reflect taste, sophistication, and timeless appeal.
            </p>
          </div>
        </div>
      </section>

      {/* =========================
          VIDEOS
      ========================= */}
      <section className="px-6 md:px-16 py-12 bg-[#FFF8EC]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-serif text-light_primary">
              Explore Legacy Decor
            </h2>

            <p className="text-gray-500 mt-2">
              Discover our collection, craftsmanship and latest creations.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map((video, index) => (
              <div
                key={video.url}
                className="bg-white rounded-xl overflow-hidden shadow-md"
              >
                <div className="aspect-[9/16] bg-black">
                  <div className="aspect-[9/16] bg-black">
                    <iframe
                      src={getDrivePreviewUrl(video.url)}
                      className="w-full h-full border-0"
                      allow="autoplay"
                      allowFullScreen
                      title={`Legacy Decor Video ${index + 1}`}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
